import { Box, Card } from "@thecb/components";
import React, { ReactChild } from "react";

type Props = {
  header: string;
  children: ReactChild[];
};

const FormContainer = ({ header, children }: Props) => {
  return (
    <Card headerText={header}>
      <Box as="form" padding="24px">
        {children}
      </Box>
    </Card>
  );
};

export default FormContainer;
